<template>
    <div>
        <ul class="ticket-list">
            <li class = "ticket-list-item" v-for="ticket in tickets" :key="ticket.id">
                <div class="d-flex justify-content-between">
                    <div>
                        <b>Ticket {{ ticket.code}}</b>
                        <span v-if="ticket.type == 1"> - bestuhlt, freie Platzwahl</span>
                        <span v-else-if="ticket.type == 2"> - Stehplatz</span>
                        <span v-else-if="ticket.type == 3"> - Block {{ ticket.block }} -  Reihe {{ ticket.row }} -  Platz {{ ticket.seat }}</span>
                    </div>
                    <div>
                        <a :href="backend + '/api/tickets/' + ticket.id + '/print'"><i class="fas fa-download ticket-button"></i></a>
                        <a href="javascript:;" v-on:click="deleteTicket(ticket.id)"><i class="fas fa-trash-alt ticket-button"></i></a>
                    </div>
                </div>
            </li>
        </ul>
        <div class="d-flex justify-content-center" v-if="!tickets.length">Keine Tickets gefunden</div>
    </div>
</template>

<script>
import axios from 'axios';
export default ({
    name: 'TicketList',
    data() {
        return {
            backend: process.env.VUE_APP_BACKEND,
        }
    },
    props: {
        tickets: {
            type: Array,
            required: true
        },
    },
    methods: {
        deleteTicket(id) {
            if(confirm("Ticket wirklich löschen?")){
                axios.delete(process.env.VUE_APP_BACKEND + '/api/tickets/' + id)
                .then(response => { this.$emit('TicketDeleted')  })
                .catch(error => {
                    if (error.response.status === 401) {
                        logout()
                    } else {
                        console.log(error);
                    }           
                });
            }
        }
    },
})
</script>

<style language="scss" scoped>
.ticket-list {
    list-style-type: none;
    padding: 5px;
}
.ticket-list-item {
    padding: 1em;
    border-radius: .5em;
    background-color: white;
    margin: .5em;
    box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
}
.ticket-list-item i {
    font-size: 1.5em;
}

.ticket-button {
    padding-right: 1em;
    color: grey;
}

.ticket-button:hover {
    color: darkgray;
}

.edit-button {
    padding-right: 1em;
    color: grey;
}

.edit-button:hover {
    color: darkgray;
}
</style>